import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import IconButton from "@material-ui/core/IconButton"
import clsx from "../../util/clsx"
import {
  IoIosArrowDropdown,
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io"

const useStyles = makeStyles(theme => ({
  IconButton: {
    fontSize: theme.spacing(6),
    background: "transparent",
    margin: "auto",
    padding: 0,
    boxSizing: "border-box",
  },
  IconFont: {
    fontSize: "inherit",
    fontWeight: 100,
    color: "#000",
  },
}))

export default ({ cls, direction, style, move, stopAnimationInterval }) => {
  const classes = useStyles({ direction })
  const Iconfont = () => {
    if (direction && direction === "LEFT") {
      return <IoIosArrowDropleftCircle className={classes.IconFont} />
    } else if (direction && direction === "RIGHT") {
      return <IoIosArrowDroprightCircle className={classes.IconFont} />
    } else {
      return <IoIosArrowDropdown className={classes.IconFont} />
    }
  }

  return (
    <IconButton
      className={clsx([classes.IconButton, style && style, cls && cls])}
      onMouseOver={move && move}
      onMouseOut={stopAnimationInterval && stopAnimationInterval}
    >
      <Iconfont />
    </IconButton>
  )
}
